import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faGraduationCap,faGears,faComputer} from "@fortawesome/free-solid-svg-icons";

const Skills = ({title, description, icon}) => {
    let faIcon =
        icon === "graduation-cap" ? faGraduationCap
        : icon === "gears" ? faGears
        : icon === "computer" ? faComputer
        : icon;

    return <div className="skill-card">
        <h2 className="skill-title">{title}</h2>
        <span className="skill-desc">{description}</span>
        <FontAwesomeIcon className="icon" icon={faIcon} />
    </div>;
}

export default Skills;
